import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';

/* import element from component folder */
import Select from '../../../components/select';
import Editor from "../../../views/combination/editor";
import Checkbox from "../../../views/combination/columebox";

/* import fetch function */
import { CreateDeviceType } from "../../../services/device";

const CreateDevice = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [source, setSource] = useState({});
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        if (name === 'deviceType')
            delete error.codeId;
        else
            delete error[name];

        if (value.length) {
            if (name === 'deviceType')
                _source.codeId = value;
            else
                _source[name] = value;
        }
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {     
            CreateDeviceType(source).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const validate = () => {
        const checkLists = ['name', 'codeId'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Create Data</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Type</div>
                        <span className='semicolon'>：</span>
                        <Select name='deviceType' select_all={ false } shadow={ false } required={ error.codeId } changHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='name' placeholder='Please enter the device name.' is-required={`${error.name}`} onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <Checkbox changeHandle={ changHandler } />
                    </div>
                    <div className="form-item">
                        <Editor source={ source } changeHandle={ changHandler } />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateDevice;